import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { useNavigation } from '@react-navigation/native';

/**
 * Safely wraps `useNavigation` from `@react-navigation/native`.
 *
 * Returns `null` when called outside a react-navigation context.
 */
export const useSafeNavigation = <
  T extends NavigationProp<ParamListBase> = NavigationProp<ParamListBase>,
>(): T | null => {
  try {
    return useNavigation<T>();
  } catch {
    return null;
  }
};
